import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from '../utils/analytics';

// Fires a pageview beacon on every route change (anonymous visitors only).
// Mounted once at the app root, inside the Router.
export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // Defer slightly so document.title reflects the new route's <title>.
    const t = setTimeout(() => {
      trackPageview(location.pathname + location.search, document.title);
    }, 350);
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);

  return null;
}
